import React, { useCallback, useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { useEffect } from "react";
import { fetchChangeCurrentCountry, getShippingInfo } from "../../../../../../api";
import _ from "lodash"
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const ShippingRow = props =>{
    const { row, country } = props;

    return <tr>
        {
            country && <td>{country}</td>
        }
        <td>{row.label}</td>
        <td>{row.time}</td>
        <td>{row.free}</td>
    </tr>
}

const LoadingShippingRow = props =>{

    return <tr className={classes.LoadingShippingRow}>
        <td>--</td>
        <td>--</td>
        <td>--</td>
    </tr>
}


const ShippingRows = props =>{
    const { infos, hasStandard, hasExpedited, hasExpress, hasCountry } = props;

    return infos.map(info => (
        <React.Fragment key={info.country}>
            {hasStandard?.(info) && <ShippingRow country={hasCountry ? info?.country: ''} row={{...info.standard}}/>}
            {hasExpedited?.(info) && <ShippingRow country={hasCountry ? info?.country: ''} row={{...info.expedited}}/>}
            {hasExpress?.(info) && <ShippingRow country={hasCountry ? info?.country: ''} row={{...info.express}}/>}
        </React.Fragment>
    ))
}


const FilterResult = props =>{
    const { infos } = props;

    // const desc = infos?.[0]?.standard ? infos[0]?.standard.desc : '';
    // const expre = infos[0]?.express ? infos[0].express.desc : "";
    // const hasStandard = _.find(infos, info => !!info.standard)
    // const hasExpedited = _.find(infos, info => !!info.expedited)
    // const hasExpress = _.find(infos, info => !!info.express)

    const hasCountry = infos?.length > 1
    const desc = !hasCountry ? _.find(infos, info => !!info?.standard?.desc)?.standard?.desc || '': ''
    const expre = !hasCountry ? _.find(infos, info => !!info?.express?.desc)?.express?.desc || '': ''

    const hasStandard = useCallback((info) => {
        return !!info.standard
    }, [])

    const hasExpedited = useCallback((info) => {
        return !!info.expedited
    }, [])

    const hasExpress = useCallback((info) => {
        return !!info.express
    }, [])

    return <div className={classes.FilterResult}>
        {
            desc && <div className={classes.Standard} dangerouslySetInnerHTML={{__html:desc}}></div>
        }
        
        {
            expre && <div className={classes.Express} dangerouslySetInnerHTML={{__html:expre}}></div>
        }
        
        <div className={classes.ShippingTableContainer}>
            <table className={classes.ShippingTable} style={{width:'100%'}}>
                <thead>
                    <tr>
                        {
                            hasCountry && <td><FormattedMessage id="country" defaultMessage="Country" /></td>
                        }
                        <td><FormattedMessage id="shipping_method" defaultMessage="Shipping Method" /></td>
                        <td><FormattedMessage id="shipping_time" defaultMessage="Shipping Time"/></td>
                        <td><FormattedMessage id="costs" defaultMessage="Costs" /></td>
                    </tr>
                </thead>

                {
                    infos?.length > 0 ? (
                        <tbody>
                        <ShippingRows hasStandard={hasStandard} hasExpedited={hasExpedited} hasExpress={hasExpress} hasCountry={hasCountry} infos={infos} />
                    </tbody>
                    ) : (
                        <tbody>
                            {
                                Array.from(new Array(2)).map((item,index)=>{
                                    return <LoadingShippingRow key={index} />
                                })
                            }
                        </tbody>
                    )
                }
                
            </table>
        </div>
    </div>
}

const FilterSelect = props =>{
    const { searchValue, selectHandle, infos } = props;

    const getGroupCountries = (infos) => {
        return _.groupBy(infos, info => (info?.country || '')?.substr(0, 1)?.toUpperCase())
    }

    const groupCountry = getGroupCountries(infos)

    const sortedKeys = Object.keys(groupCountry).sort()

    return <React.Fragment>
        <span className={classes.ShippingTo}><FormattedMessage id="shipping_to" defaultMessage="Shipping To" />:</span>

        <select value={searchValue} className={classes.FilterSelect} onChange={selectHandle}>
            <option value={'-'} key={'-'}>{'-'}</option>
            {
                sortedKeys?.map(k => <optgroup label={k} key={k}>
                    {
                        groupCountry?.[k]?.map(info => <option value={info.country} key={info.country}>{info.country}</option>)
                    }
                </optgroup>)
            }
        </select>
    </React.Fragment>
}

const ShippingInfo = props =>{
    useStyles(classes);
    const { productId } = props;
    const [countries, setCountries] = useState()
    const [data,setData] = useState({
        searchValue: "",
        infos: [{
            country: 'Country/Region',
            standard:{
                free:'-',
                time:'-',
                label:'-'
            }
        }],
        filteredDisplyInfos: []
    });

    const global = useSelector(state=>state.global);

    useEffect(async ()=>{
        let params = productId ? {productId} : {};
        let response = await getShippingInfo(params).catch(e=>[]);
        if(response?.code === 200){
            let _infos = response?.result;

            // _infos.push(
            //     {
            //         country: {
            //             label: 'Country/Region',
            //             value:'-'
            //         },
            //         standard:{
            //             free:'-',
            //             time:'-',
            //             label:'-'
            //         }
            //     }
            // );

            let infos = _infos ? _infos.map( info => ({standard: info.standard, expedited: info.expedited, express: info.express, country: info.country.label, countryValue: info.country.value}) ) : []
            
            let countries = {};

            if(_infos){
                _.each(_infos, info => {
                    countries[info.country.value] = info.country.label
                })
            }
            
            let searchkey = countries[(global?.country || "US")] || '';

            setData(state => {
                return{
                    searchValue: searchkey,
                    infos: infos,
                    filteredDisplyInfos: searchkey ? infos.filter(p => p.country.toLowerCase() === searchkey.toLowerCase()) :infos
                }
            });
            setCountries({...countries})
        }
    },[]);

    const selectHandle = (e) =>{
        e.preventDefault()
        let countryLabel = e.target.value
        let countryValue = Object.entries(countries || {})?.find(c => c?.[1] == countryLabel)?.[0] || '-'

        setData(state =>{
            fetchChangeCurrentCountry(countryValue)
            return {
                ...state,
                searchValue: countryLabel,
                filteredDisplyInfos: countryLabel ? state.infos.filter(p => p.country.toLowerCase() === countryLabel.toLowerCase()) :state.infos,
            }
        });
    }

    const { searchValue, infos, filteredDisplyInfos } = data;

    return <div className={`${classes.ShippingInfo} ${props?.isPolicy ? classes.ShippingPolicy : ''}`}>
        <div className={classes.Hd} onClick={(e) => { e.nativeEvent.stopImmediatePropagation()}}>
            <FilterSelect selectHandle={selectHandle} searchValue={searchValue} infos={infos}  />
        </div>

        <div className={classes.Bd}>
            <FilterResult infos={filteredDisplyInfos} />
        </div>
    </div>
}

export default ShippingInfo;